<script setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 3.5H10.5C6.729 3.5 4.843 3.5 3.672 4.672C2.501 5.844 2.5 7.729 2.5 11.5V13.5C2.5 17.271 2.5 19.157 3.672 20.328C4.844 21.499 6.729 21.5 10.5 21.5H12.5C16.271 21.5 18.157 21.5 19.328 20.328C20.499 19.156 20.5 17.271 20.5 13.5V12.5"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 12.5H11.5M7.5 16.5H15.5M21.5 6C21.5 6.92826 21.1313 7.8185 20.4749 8.47487C19.8185 9.13125 18.9283 9.5 18 9.5C17.0717 9.5 16.1815 9.13125 15.5251 8.47487C14.8688 7.8185 14.5 6.92826 14.5 6C14.5 5.07174 14.8688 4.1815 15.5251 3.52513C16.1815 2.86875 17.0717 2.5 18 2.5C18.9283 2.5 19.8185 2.86875 20.4749 3.52513C21.1313 4.1815 21.5 5.07174 21.5 6Z"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
